import { render, staticRenderFns } from "./kadenze-course-card.vue?vue&type=template&id=7d566e50&"
import script from "./kadenze-course-card.vue?vue&type=script&lang=js&"
export * from "./kadenze-course-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports